const Referral = {
  TYPE_ALL: "All",
  TYPE_REQUEST: "Request",
  TYPE_REFERRAL: "Referral"
};

export default Referral;
